module.exports = __webpack_public_path__ + "media/featured/Oprah-63803801.png";